interface IProps {
  color?: string;
  width?: string;
}
const ManualCASIcon = ({ color = '#fff', width = '13' }: IProps) => {
  return (
    <svg width={width} height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1436 0C10.6618 0 10.2872 0.401449 10.2872 0.856425V2.86367C9.21662 1.36493 7.47701 0.428212 5.57681 0.428212C3.0343 0.428212 0.81295 2.06077 0.036815 4.46947C-0.0970014 4.92444 0.143868 5.40618 0.598844 5.54C1.05382 5.67381 1.53556 5.43295 1.66937 4.97797C2.20464 3.29188 3.78367 2.14106 5.57681 2.14106C6.91498 2.14106 8.14609 2.81014 8.89546 3.85391H7.71788C7.23614 3.85391 6.86145 4.25536 6.86145 4.71034C6.86145 5.19208 7.23614 5.56676 7.71788 5.56676H11.1436C11.5986 5.56676 12 5.19208 12 4.71034V0.856425C12 0.401449 11.5986 0 11.1436 0Z"
        fill={color}
      />
    </svg>
  );
};

export default ManualCASIcon;
